import { useQuery } from "@tanstack/vue-query"

export const usePointsOfInterest = () => {
    return useQuery({
        queryKey: ['pointsOfInterest'],
        queryFn: async () => {
            const baseUrl = import.meta.env.BASE_URL || '/';
            const request = await fetch(`${baseUrl}content.json`);
            const data = await request.json();
            return data;
        },
    })
}